module.exports = __webpack_public_path__ + "static/media/albatard.8ff4bc4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/albatard.mp3
// module id = 21
// module chunks = 0